<form [formGroup]="form"
      (ngSubmit)="onSubmit()"
>
  <form-errors></form-errors>
  <p>Are you sure you want to delete this task link?<br>There is no undo</p>
  <button a-button class="btn_warn button" [pending]="_formService.isPending$ | async" (click)="onSubmit()">Delete</button>
  <button a-button class="btn_text button" (click)="onCancel()">Cancel</button>
</form>
